import { useTranslation } from "react-i18next";
import FooterPageBoilerplate from "./FooterPageBoilerplate";

export default function RefundPolicy() {
  const { t } = useTranslation();

  return (
    <FooterPageBoilerplate title={t("refundPolicyTitle")}>
      {t("refundPolicyDescription")}
    </FooterPageBoilerplate>
  );
}
